export default "__VITE_ASSET__bmR1gPbe__"